var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isInitLoading,
          expression: "isInitLoading",
        },
      ],
      attrs: { block: _vm.isInitLoading },
    },
    [
      !_vm.isInitLoading
        ? _c(
            "div",
            [
              _c(
                "el-steps",
                {
                  attrs: {
                    active: _vm.getCurrentStep,
                    "align-center": "",
                    "finish-status": "success",
                    "show-icon": "",
                  },
                },
                [
                  _c("el-step", {
                    attrs: { title: _vm.ReplaceContent.choiceTitle },
                  }),
                  _c("el-step", {
                    attrs: { title: _vm.ReplaceContent.fillEmp },
                  }),
                  _c("el-step", { attrs: { title: "完成" } }),
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  staticStyle: { "margin-top": "20px" },
                  model: {
                    value: _vm.stepActive,
                    callback: function ($$v) {
                      _vm.stepActive = $$v
                    },
                    expression: "stepActive",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "", name: "0" } },
                    [
                      _c(
                        "el-card",
                        { attrs: { header: _vm.ReplaceContent.choiceTitle } },
                        [
                          [
                            _c("avue-crud", {
                              ref: "crud",
                              attrs: {
                                data: _vm.employeeList,
                                option: _vm.optionEmployeeEndorse,
                                page: _vm.page,
                                "table-loading": _vm.listLoading,
                              },
                              on: {
                                "update:page": function ($event) {
                                  _vm.page = $event
                                },
                                "on-load": _vm.getEmployeeList,
                                "search-change": _vm.searchChange,
                                "search-reset": _vm.searchChange,
                                "size-change": _vm.sizeChange,
                                "current-change": _vm.currentChange,
                                "selection-change": _vm.selectionChange,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "menuRight",
                                    fn: function (ref) {
                                      return [
                                        _vm.isReplaceEmp === 0 && _vm.isShowMore
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-upload",
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "15px",
                                                    },
                                                    attrs: {
                                                      "auto-upload": false,
                                                      loading: _vm.listLoading,
                                                      "on-change":
                                                        _vm.onUploadTemp,
                                                      "show-file-list": false,
                                                      action: "action",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          icon: "el-icon-upload2",
                                                          type: "primary",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "导入文件批量替换"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      loading: _vm.listLoading,
                                                      icon: "el-icon-download",
                                                      type: "primary",
                                                    },
                                                    on: {
                                                      click: _vm.onDownload,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t模板\n\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "menuLeft",
                                    fn: function (ref) {
                                      return [
                                        _vm.isReplaceEmp === 0 && _vm.isShowMore
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "margin-top": "10px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-tag",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      type: "warning",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "替换人员一次最多替换20人"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "menu",
                                    fn: function (ref) {
                                      var row = ref.row
                                      var index = ref.index
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-sort",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleReplaceSingle(
                                                  row,
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.ReplaceContent.choiceTi
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2395791315
                              ),
                            }),
                          ],
                        ],
                        2
                      ),
                      _c(
                        "el-row",
                        { attrs: { justify: "center", type: "flex" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled:
                                  _vm.employeeSelectedList.length == 0 ||
                                  _vm.employeeSelectedList.length > 20,
                                type: "primary",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.handleStep2.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t\t下一步\n\t\t\t\t\t")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "", name: "1" } },
                    [
                      _c(
                        "el-card",
                        { attrs: { header: _vm.ReplaceContent.fillEmp } },
                        [
                          [
                            _c(
                              "avue-crud",
                              {
                                ref: "crud",
                                attrs: {
                                  data: _vm.employeeReplaceList,
                                  option: _vm.optionEmployeeReplace,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "menu",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                icon: "el-icon-delete",
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleRemoveEmployee(
                                                    scope.row,
                                                    scope.index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t移除\n\t\t\t\t\t\t\t\t"
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  54362336
                                ),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between",
                                        "margin-bottom": "10px",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "warning",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t由于保险公司系统处理有延迟，最终承保生效时间请以保险公司系统为准\n\t\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              2
                            ),
                          ],
                        ],
                        2
                      ),
                      _vm.configData.attachForm
                        ? _c("form-attach", {
                            ref: "refAttach",
                            staticClass: "u-m-b-20",
                            attrs: {
                              attachFormAllData: _vm.configData.attachForm,
                            },
                          })
                        : _vm._e(),
                      _c(
                        "el-row",
                        { attrs: { justify: "left", type: "flex" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.isNoticeRead,
                                callback: function ($$v) {
                                  _vm.isNoticeRead = $$v
                                },
                                expression: "isNoticeRead",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "16px",
                                    "font-weight": "bolder",
                                  },
                                },
                                [_vm._v("我已知悉本次替换预计生效时间")]
                              ),
                            ]
                          ),
                          _c(
                            "el-tag",
                            { attrs: { size: "mini", type: "danger" } },
                            [_vm._v(_vm._s(_vm.effectiveDate) + "零时")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { justify: "center", type: "flex" } },
                        [
                          _vm.isShowMore
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    loading: _vm.isShowLoading,
                                    type: "primary",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.handleStep1.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v("\n\t\t\t\t\t\t上一步\n\t\t\t\t\t")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled:
                                  !_vm.isNoticeRead ||
                                  _vm.employeeReplaceList.length == 0,
                                loading: _vm.isShowLoading,
                                type: "primary",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.onHandleStep3Temp.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.ReplaceContent.submit) +
                                  "\n\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "", name: "2" } },
                    [
                      _c(
                        "el-row",
                        { attrs: { justify: "center", type: "flex" } },
                        [
                          _c(
                            "avue-crud",
                            {
                              ref: "crud",
                              attrs: {
                                data: _vm.employeeResultList,
                                option: _vm.optionEmployeeResult,
                              },
                            },
                            [
                              !_vm.replaceSucceed
                                ? _c(
                                    "template",
                                    { slot: "header" },
                                    [
                                      _c("el-alert", {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                        attrs: {
                                          center: "",
                                          "show-icon": "",
                                          title:
                                            "替换批单处理中，请不要关闭本页面，关闭将会导致剩余批单处理失败！",
                                          type: "warning",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "template",
                                    { slot: "header" },
                                    [
                                      _c("el-alert", {
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                        attrs: {
                                          center: "",
                                          "show-icon": "",
                                          title: "替换批单处理成功！",
                                          type: "success",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          staticStyle: { "margin-top": "16px" },
                          attrs: { justify: "center", type: "flex" },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.handleGoPolicy.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v("返回保单")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "base-form-dialog",
        {
          ref: "hint_repeat_again",
          attrs: {
            formDataListTemp: _vm.repeatEmpList,
            "btn-left-text": "修改投保人员",
            "btn-right-text": "确认再次投保",
            width: "50%",
          },
          on: { onClickRight: _vm.onClickRight },
        },
        [
          _c(
            "template",
            { slot: "form_top" },
            [
              _c("span", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("当前被保企业：" + _vm._s(_vm.currentRepeatUnit)),
              ]),
              _c("el-alert", {
                staticStyle: { margin: "10px 0", width: "100%" },
                attrs: {
                  closable: false,
                  title:
                    "以下投保人员已通过其他企业投保，请确认是否需要再次投保？",
                  type: "warning",
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "base-form-dialog",
        {
          ref: "hint_repeat",
          attrs: {
            formDataListTemp: _vm.allRepeatEmpList,
            "btn-right-text": "修改投保人员",
            "form-option-num-temp": "1",
            width: "50%",
          },
        },
        [
          _c("template", { slot: "form_top" }, [
            _c(
              "span",
              { staticStyle: { "font-weight": "bold", color: "red" } },
              [_vm._v("以下投保人员还未到期，不能替换")]
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }